import { WorkAttributeStoreModel } from "../models";

export interface CompanySettingState {
    workAttibutes: WorkAttributeStoreModel[]
}

export const initialCompanySettingState: CompanySettingState = {
    workAttibutes: []
};